import navigatorController from './navigator'
import navigatorPreview from './navigatorPreview'
import navigatorView from './navigatorView.vue'

export {
  navigatorController,
  navigatorPreview,
  navigatorView
}
